var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWooshAnim(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 103 90",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t#woosh1 {\n\t\t\tanimation-name: woosh1_s_do, woosh1_s_da;\n\t\t\tanimation-play-state: paused;\n\t\t\tanimation-duration: 2000ms;\n\t\t\tanimation-fill-mode: forwards;\n\t\t\tanimation-timing-function: linear;\n\t\t\tanimation-direction: normal;\n\t\t\tanimation-iteration-count: 1;\n\t\t}\n\t\t@keyframes woosh1_s_do {\n\t\t\t0% {stroke-dashoffset: -114}\n\t\t\t2.5% {stroke-dashoffset: -114}\n\t\t\t37% {stroke-dashoffset: 0}\n\t\t\t100% {stroke-dashoffset: 0}\n\t\t}\n\n\n\t\t#woosh2 {\n\t\t\tanimation-name: woosh2_s_do, woosh2_s_da;\n\t\t\tanimation-play-state: paused;\n\t\t\tanimation-duration: 2000ms;\n\t\t\tanimation-fill-mode: forwards;\n\t\t\tanimation-timing-function: linear;\n\t\t\tanimation-direction: normal;\n\t\t\tanimation-iteration-count: 1;\n\t\t}\n\t\t@keyframes woosh2_s_do {\n\t\t\t0% {stroke-dashoffset: -148}\n\t\t\t32% {stroke-dashoffset: 0}\n\t\t\t100% {stroke-dashoffset: 0}\n\t\t}\n\n\n\t\t#woosh3 {\n\t\t\tanimation-name: woosh3_s_do, woosh3_s_da;\n\t\t\tanimation-play-state: paused;\n\t\t\tanimation-duration: 2000ms;\n\t\t\tanimation-fill-mode: forwards;\n\t\t\tanimation-timing-function: linear;\n\t\t\tanimation-direction: normal;\n\t\t\tanimation-iteration-count: 1;\n\t\t}\n\t\t@keyframes woosh3_s_do {\n\t\t\t0% {stroke-dashoffset: -102}\n\t\t\t2.5% {\n\t\t\t\tstroke-dashoffset: -102;\n\t\t\t\tanimation-timing-function: cubic-bezier(0.510000, 0.040000, 0.455000, 0.960000)\n\t\t\t}\n\t\t\t37% {stroke-dashoffset: 0}\n\t\t\t100% {stroke-dashoffset: 0}\n\t\t}\n\n\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "woosh02"
  }, /*#__PURE__*/React.createElement("g", {
    id: "woosh03",
    transform: "matrix(0.90000000000000 0 0 0.90000000000000 6 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "woosh1",
    className: "animate",
    d: "M85.995961,89.402462C56.958033,89.455939,39.396351,89.474538,33.310914,89.458261C30.737990,89.451379,25.446502,89.674033,21.277659,85.958216C16.894143,82.051054,16.920771,72.842716,21.277659,68.364003C27.066829,62.412960,41.757472,63.774611,41.757472,77.172875",
    transform: "matrix(1 0 0 -1 0 154.46400000000000)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeDashoffset: -114,
    strokeDasharray: "114,1000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "woosh2",
    d: "M101.100490,45.402462C50.508339,45.455939,22.073281,45.474538,15.795315,45.458261C13.140990,45.451379,7.682092,45.674033,3.381357,41.958216C-1.140844,38.051054,-1.113373,28.842716,3.381357,24.364003C9.353683,18.412961,24.509103,19.774611,24.509103,33.172874",
    transform: "matrix(1 0 0 1 -0.05080345999999 0)",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeDashoffset: -148,
    strokeDasharray: "148,1000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "woosh3",
    d: "M86.950212,25.260003C66.971527,25.313479,53.843201,25.332079,47.565235,25.315802C44.910910,25.308920,39.452012,25.531574,35.151277,21.815757C30.629076,17.908595,30.656547,8.700257,35.151277,4.221544C41.123603,-1.729499,56.279023,-0.367848,56.279023,13.030416",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeDashoffset: -102,
    strokeDasharray: "102,1000"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWooshAnim);
export default __webpack_public_path__ + "static/media/wooshAnim.f4930d2e.svg";
export { ForwardRef as ReactComponent };